import { render, staticRenderFns } from "./club-item.vue?vue&type=template&id=a3680b6e&scoped=true"
import script from "./club-item.vue?vue&type=script&lang=js"
export * from "./club-item.vue?vue&type=script&lang=js"
import style0 from "./club-item.vue?vue&type=style&index=0&id=a3680b6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3680b6e",
  null
  
)

export default component.exports